// networkStatusService.js
export const networkStatus = async (url, token, minSpeedMbps = 1, testDurationMs = 3000) => {
    const CHUNK_SIZE_BYTES = 100 * 1024;
    const MIN_THRESHOLD_MBPS = 0.85;

    let totalBytes = 0;
    const startTime = performance.now();

    try {
        while (performance.now() - startTime < testDurationMs) {
            const response = await fetch(`${url}?_=${Date.now()}`, {
                cache: "no-store",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) throw new Error("Network response not ok");

            const blob = await response.blob();
            totalBytes += blob.size;

            if (blob.size < CHUNK_SIZE_BYTES) break;
        }

        const durationSeconds = (performance.now() - startTime) / 1000;
        const speedMbps = (totalBytes * 8) / (durationSeconds * 1_000_000);

        // console.log(`Average download speed: ${speedMbps.toFixed(2)} Mbps`);

        if (speedMbps < MIN_THRESHOLD_MBPS) {
            return false;
        }

        return speedMbps >= minSpeedMbps;
    } catch (error) {
        console.error("Speed test failed:", error);
        return false;
    }
};
